import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Tax from "./Tax";

const EditTax = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Purchase Tax - View</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
                <Tax />
            </div>
        </div>
  );
};

export default EditTax;
